const dashboardChartMixin = {
    props: {
        chartSettings: {
            type: Object,
            required: true,
        },
        selectedPeriod: {
            type: String,
            required: true,
        },
        userType: {
            type: Object,
            required: true,
        },
        trackers: {
            type: Array,
            required: true,
        },
    },

    mounted() {
        this.fetchChartData(true)
    },

    watch: {
        chartSettings: {
            handler() {
                this.reflowChart()
            },
            deep: true
        },
        selectedPeriod() {
            this.fetchChartData()
        },
        'userType.value'() {
            this.fetchChartData()
        },
        trackers() {
            this.fetchChartData()
        },
    },

    methods: {
        reflowChart() {
            if (this.$refs.chart) {
                this.$refs.chart.chart.reflow()
            }
        },
        fetchChartData() {
            console.log("That's method from mixin. Please implement one regarding your component needs.")
        },
    }
}

export default dashboardChartMixin
